import React from "react";
import './Message.scss';

type MessageProps = {
    children: React.ReactNode,
    className?: string,
    type?: 'success'|'error'|'warning'|'information',
};

function Message(props: MessageProps) {

    return (
        <div className={`message message-${props.type ?? 'information'} ${props.className}`}>{props.children}</div>
    );
}

export default Message;
